import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbDate, NgbDateStruct, NgbInputDatepicker, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';

export class SelectedDates {
	startDate: NgbDate;
	endDate: NgbDate;
}
@Component({
	selector: 'app-range-date-picker',
	templateUrl: './range-date-picker.component.html',
	styleUrls: ['./range-date-picker.component.scss'],
	viewProviders: [DatePipe],
	encapsulation: ViewEncapsulation.None,
})
export class RangeDatePickerComponent implements OnChanges {

	@Output() selectedDates: EventEmitter<SelectedDates> = new EventEmitter<SelectedDates>();
	@Output() selectedDatesClear: EventEmitter<SelectedDates> = new EventEmitter<SelectedDates>();
	@Output() inputDateChange: EventEmitter<string> = new EventEmitter<string>();
	maxDate: NgbDateStruct;
	minDate: NgbDateStruct;

	hoveredDate: NgbDate | null = null;

	fromDate: NgbDate | null;
	toDate: NgbDate | null;

	inputDate: string = "";
	@ViewChild("datepicker") dp: NgbInputDatepicker;
	@Input() isDefaultFinancialDateSelected;

	@Input() startDate;
	@Input() endDate;

	@Output() startDateEmit = new EventEmitter();
	@Output() endDateEmit = new EventEmitter();
	@Output() applyDate = new EventEmitter();


	constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, public datePipe: DatePipe, private storageService: StorageService) {
		this.onClear();
		// this.getAndAssignFinancialDate();
	}

	ngOnChanges(changes: SimpleChanges): void {
		const dt1 = this.formatter?.parse(this.startDate) as any;
		const dt2 = this.formatter?.parse(this.endDate) as any;
		this.fromDate = dt1 ? dt1 : null;
		this.toDate = dt2 ? dt2 : null;

		if (!this.startDate || !this.endDate) {
			this.inputDate = null;
		} else {
			this.inputDate = this.startDate + ' - ' + this.endDate;
		}
	}

	ngOnInit(): void {
		// this.getCurrentDate();

		this.getAndAssignFinancialDate();


	}

	getCurrentDate() {
		if (!this.inputDate) {
			const today = new Date();
			const januaryFirst2023 = new Date(2023, 0, 1);
			this.fromDate = this.convertToNgbDateStruct(januaryFirst2023);
			this.toDate = this.convertToNgbDateStruct(today);
			this.inputDate = this.formatter.format(this.fromDate) + ' - ' + this.formatter.format(this.toDate);
			this.onApply();
		}
	}

	convertToNgbDateStruct(date: Date): any {
		return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
	}

	onDateSelection(date: NgbDate) {
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date && (date.equals(this.fromDate) || date.after(this.fromDate))) {
			this.toDate = date;
		} else {
			this.toDate = null;
			this.fromDate = date;
		}
		this.inputDate = this.formatter.format(this.fromDate) + ' - ' + this.formatter.format(this.toDate);
		const formattedFromDate = this.formatter.format(this.fromDate);
		const formattedToDate = this.formatter.format(this.toDate);
		// this.inputDateChange.emit(this.inputDate);

		this.startDateEmit.emit(formattedFromDate);
		this.endDateEmit.emit(formattedToDate);
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		);
	}
	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}
	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}
	isStartDate(date: NgbDate) {
		return date.equals(this.fromDate);
	}
	isEndDate(date: NgbDate) {
		return date.equals(this.toDate);
	}
	onClear() {
		this.inputDate = null;
		this.fromDate = null;
		this.toDate = null;
		this.selectedDatesClear.emit();
		this.startDateEmit.emit(null);
		this.endDateEmit.emit(null);
		this.onApply(false)
	}
	onApply(isClose = true) {

		this.applyDate.emit();
		this.selectedDates.emit({
			startDate: this.fromDate,
			endDate: this.toDate
		});
		if (isClose) {
			this.dp?.close();
		}
	};


	getAndAssignFinancialDate() {
		const financialYearDates = this.storageService.retrieve('financialYear');
		const NgbFinancialStartDate = financialYearDates?.financialYearStartDate;
		const NgbFinancialEndDate = financialYearDates?.financialYearEndDate;
		const dt1 = this.formatter?.parse(NgbFinancialStartDate) as any;
		const dt2 = this.formatter?.parse(NgbFinancialEndDate) as any;
		this.fromDate = dt1;
		this.toDate = dt2
		this.inputDate = this.formatter?.format(this.fromDate) + ' - ' + this.formatter?.format(this.toDate);
		this.startDateEmit.emit(NgbFinancialStartDate);
		this.endDateEmit.emit(NgbFinancialEndDate);
	}

}